import Carousel from "@stimulus-components/carousel"

const SESSION_KEY_PREFIX = "photoSlideshowPlayState:"

export default class extends Carousel {
  static targets = ["playButton", "buttonText"];

  connect() {
    super.connect()
    this.restorePlayState()
  }

  get defaultOptions() {
    return {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoplay: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    }
  }

  togglePlay() {
    if (this.swiper.autoplay.running) {
      this.swiper.autoplay.stop();
      this.buttonTextTarget.innerHTML = this.playIconSvg;
      this.playButtonTarget.setAttribute("aria-label", "Play slideshow");
    } else {
      this.swiper.autoplay.start();
      this.buttonTextTarget.innerHTML = this.pauseIconSvg;
      this.playButtonTarget.setAttribute("aria-label", "Pause slideshow");
    }
    this.savePlayState()
  }

  // Persist current play/pause state in sessionStorage
  savePlayState() {
    const key = this.sessionKey()
    const playing = this.swiper.autoplay.running
    window.sessionStorage.setItem(key, JSON.stringify(playing))
  }

  // Restore autoplay state (+ icon + aria-label) from sessionStorage
  restorePlayState() {
    const key = this.sessionKey()
    const data = window.sessionStorage.getItem(key)

    if (data !== null) {
      try {
        const playing = JSON.parse(data)
        if (playing) {
          this.swiper.autoplay.start()
          this.buttonTextTarget.innerHTML = this.pauseIconSvg
          this.playButtonTarget.setAttribute("aria-label", "Pause slideshow")
        } else {
          this.swiper.autoplay.stop()
          this.buttonTextTarget.innerHTML = this.playIconSvg
          this.playButtonTarget.setAttribute("aria-label", "Play slideshow")
        }
      } catch {
        // ignore parse errors
      }
    } else {
      // Ensure initial aria/icon matches current state
      if (this.swiper.autoplay.running) {
        this.buttonTextTarget.innerHTML = this.pauseIconSvg
        this.playButtonTarget.setAttribute("aria-label", "Pause slideshow")
      } else {
        this.buttonTextTarget.innerHTML = this.playIconSvg
        this.playButtonTarget.setAttribute("aria-label", "Play slideshow")
      }
    }
  }

  // Create a page-scoped key, using button id when available, else index fallback
  sessionKey() {
    // Use one global key so all slideshows share the same state
    return SESSION_KEY_PREFIX + 'global'
  }

  // Heroicons (24/solid) inline SVGs to match existing styling
  get playIconSvg() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
           fill="currentColor" aria-hidden="true" class="h-6 w-6">
        <path d="M5.25 4.5v15l13.5-7.5-13.5-7.5z"/>
      </svg>
    `;
  }

  get pauseIconSvg() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
           fill="currentColor" aria-hidden="true" class="h-6 w-6">
        <path d="M6.75 5.25h3v13.5h-3V5.25z"/>
        <path d="M14.25 5.25h3v13.5h-3V5.25z"/>
      </svg>
    `;
  }

  disconnect() {
    this.swiper.destroy();
  }
}
